import * as React from "react";
import { useToggle } from "react-use";
import { isMobileLayout } from "../../utils";
import { useVerificationsRedux } from "../../redux";
import { Loader, Panel } from "@deque/cauldron-react";
import { Footer, UcsbHeader } from ".";

export const Layout = (props: any) => {
	const isMobile: boolean = isMobileLayout();
	const [expanded, expandedToggle] = useToggle(isMobile);
	const verificationRedux = useVerificationsRedux();

	const handleExpand = () => {
		expandedToggle();
	};

	return (
		<div className={expanded ? "wrapper expanded" : "wrapper"}>
			<main>
				<UcsbHeader />
				<div style={{paddingLeft: '16px', paddingRight: '16px'}} className="content container-fluid">
					<Panel className="main-content">
						{verificationRedux.state.working ? <Loader label="Loading..." /> : props.children}
					</Panel>					
				</div>
				<Footer />
			</main>
		</div>
	);
};

export default Layout;
